var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#9FA4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 26.6665C40 31.0848 36.4183 34.6665 32 34.6665C27.5817 34.6665 24 31.0848 24 26.6665C24 22.2482 27.5817 18.6665 32 18.6665C36.4183 18.6665 40 22.2482 40 26.6665Z",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6665 29.5854C21.216 30.4735 18.6665 33.6057 18.6665 37.3334C18.6665 41.7517 22.2482 45.3334 26.6665 45.3334C31.0848 45.3334 34.6665 41.7517 34.6665 37.3334C34.6665 36.3272 34.4807 35.3643 34.1416 34.4772",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 43.2964C33.4154 44.5631 35.2844 45.3334 37.3333 45.3334C41.7516 45.3334 45.3333 41.7517 45.3333 37.3334C45.3333 33.6057 42.7838 30.4735 39.3333 29.5854",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInCategory);
export default __webpack_public_path__ + "static/media/inCategory.090231ef139e98cafdadb4c776701eee.svg";
export { ForwardRef as ReactComponent };